import {cookie} from '../modules/cookie';

/*  */
var novelties = function(el){
    var closeBtn = el.querySelector('[data-novelties-close]'),
        setCookie = function(expires){
            var options = {},
                domains = ['.kinoafisha.spb.ru', '.kinoafisha.msk.ru', '.kinoafisha.info'],
                i = 0,
                l = domains.length;

            options.expires = expires;
            options.path = '/';

            for(i; i<l; i++){
                options.domain = domains[i];
                cookie.setCookie('ka_rating', '1', options);
            }
        };
    //
    closeBtn.onclick = function(){
        delete this.onclick;
        el.parentNode.removeChild(el);
        setCookie(3600*24*365);
    }
}

export {novelties};


